import { Vue, Component, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';

@Component({
    name: 'popup-card',
    components: {
        'material-icon': GoogleMaterialIcon,
    },
})

export default class PopupCard extends Vue {

    @Prop({default: null})
    private content: any;

    @Prop()
    private cardName!: string;

    private onClose() {
        this.$emit('onClose', false);
    }

}
